<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div class="text each-row">
        <span>{{ this.question }}</span>
      </div>
      <div>
        <div class="checkboxes">
          <div>
            <div v-for="qualification in qualificationsFirstHalf">
              <input type="checkbox" v-model="precodes[qualification.precode]">
              <span class="checkbox-text">{{qualification.option}}</span>
            </div>
          </div>
          <div>
            <div v-for="qualification in qualificationsSecondHalf">
              <input type="checkbox" v-model="precodes[qualification.precode]">
              <span class="checkbox-text">{{qualification.option}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="each-row">
        <StudyNavigation></StudyNavigation>
      </div>
    </div>
  </div>
</template>

<script>

  import {mapGetters} from "vuex"
  import {
    GET_NEXT_STUDY_STEP_ROUTE, LOADING_COMPLETED_SUCCESS, R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_LANGUAGE,
    SET_SURVEY_SELECTED_QUALIFICATIONS
  } from "../../services/constants"
  import StudyNavigation from "../views/StudyNavigation"

    export default {
      name: "SurveyQualificationSinglePunch",

      components: {StudyNavigation},

      props: {
        qualification: {
          type: Object,
          default(){
            return {}
          },
        }
      },

      created(){
        this.precodes = this.createPrecodes()
        this.setSelections()
      },

      watch: {
        '$route'() {
          this.precodes = this.createPrecodes()
          this.setSelections()
        }
      },

      data(){
        return{
          precodes: this.createPrecodes()
        }
      },

      computed:{
        ...mapGetters([
          GET_NEXT_STUDY_STEP_ROUTE,
        ]),

        numberOfCheckboxes(){
          return this.qualification.options ? this.qualification.options.length : 0
        },
        qualificationsFirstHalf(){
          let len = this.numberOfCheckboxes
          return this.qualification.options ? this.qualification.options.slice(0, len/2) : []
        },
        qualificationsSecondHalf(){
          let len = this.numberOfCheckboxes
          return this.qualification.options ? this.qualification.options.slice(len/2) : []
        },
        question(){
          return `If you would like to limit respondents based on ${this.qualification.name},
          select desired qualifications below.  Or skip to get a random sampling`
        },
      },

      methods:{
        handleSubmit(){
          let arr = this.$store.state.dataModule.selectedQualifications.qualifications
          let id = this.getQualificationID()
          arr = this.removeObjectWithId(arr, id)
          let precodesArray = this.convertPrecodesToArray()
          if (precodesArray.length > 0){
            arr.push({'id': this.getQualificationID(), 'precodes': precodesArray})
            console.log(arr)
            this.$store.commit(SET_SURVEY_SELECTED_QUALIFICATIONS, {"qualifications": arr})
          }
          this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE])
        },

        removeObjectWithId(arr, id){
          return arr.filter(qual => qual.id !== id);
        },

        getQualificationID(){
          return this.qualification.id
        },
        setSelections(){
          let arr = this.$store.state.dataModule.selectedQualifications.qualifications
          let selections = arr.filter(qual => qual.id === this.getQualificationID())
          if (selections[0] && selections[0].precodes.length > 0){
            for (let precode of selections[0].precodes){
              this.precodes[precode] = true
            }
          }
        },
        createPrecodes(){
          let obj = {}
          if (this.qualification){
            let options = this.qualification.options
            for (let code of options){
              obj[code.precode] = false
            }
          }
          return obj
        },
        convertPrecodesToArray(){
          return Object.keys(this.precodes)
            .filter(k => this.precodes[k])
            .map(Number)
        },

      },
    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .text{
    text-align: center;
  }

  .checkboxes{
    display: flex;
    flex-direction: row;
    @media #{$mobile} {
      flex-direction: column;
      padding-left: 5em;
    }
    justify-content: space-around;
  }

  .checkbox-text{
    padding: 0 10px;
  }

  .filler{
    display: inline-block;
    width: 20%;
  }

  span {
    font-size: 1.17em;
  }

  .each-row{
    padding: 5% 0;
  }


</style>
